export class ScaleValidateModel {
    hasInvalidScale:boolean;
    hasInvalidScaleMeasures: boolean;
    hasModifiedScales: boolean;

    constructor() {
        this.hasInvalidScale = false;
        this.hasInvalidScaleMeasures = false;
        this.hasModifiedScales = false;
    }
}


/** WEBPACK FOOTER **
 ** ./app/scalevalidate/models/ScaleValidateModel.ts
 **/